module.exports = __webpack_public_path__ + "media/images/sk2500-0b5290f45ff2e7b3ddae9c6081ffd751.svg";